import { createAsyncActions } from '@wahaaabello/redux-async-actions';

const [, fetchTargetsSuccess, fetchTargetsFailure] = createAsyncActions(
  'FETCH_TARGETS'
);

const [
  fetchTargetRequest,
  fetchTargetSuccess,
  fetchTargetFailure
] = createAsyncActions('FETCH_TARGET');

const [
  fetchTargetPageRequest,
  fetchTargetPageSuccess,
  fetchTargetPageFailure
] = createAsyncActions('FETCH_TARGET_PAGE');

const [fetchMyTargetsRequest] = createAsyncActions('FETCH_MY_TARGETS');

const [fetchTargetsByCategoryRequest] = createAsyncActions(
  'FETCH_TARGETS_BY_CATEGORY'
);

const [searchTargetsRequest] = createAsyncActions('SEARCH_TARGETS');

const targetsActions = {
  fetchMyTargetsRequest,
  fetchTargetsByCategoryRequest,
  searchTargetsRequest,
  fetchTargetsSuccess,
  fetchTargetsFailure,
  fetchTargetRequest,
  fetchTargetSuccess,
  fetchTargetFailure,
  fetchTargetPageRequest,
  fetchTargetPageSuccess,
  fetchTargetPageFailure
};

export default targetsActions;
